import { useEffect, useState } from 'react'
import { WellHistoryFieldsView } from '../../../../../types/form-types'
import { useGetWellData } from '../../../../hooks/use-api'
import { useParamsOr404 } from '../../../../hooks/use-params-or-404'
import { useNavigate } from 'react-router-dom'
import { Button, ButtonsContainer, FormField, Heading, ReadOnlyField, RecordContent } from '@msaf/core-react'

interface HistoryDetailsProps {
  mode?: 'edit' | 'view'
}

export function getWellHistoryLinks(id: string, historyId: string, mode: 'view' | 'edit' = 'view') {
  return [{ path: `/wells/${id}/${mode}/history/${historyId}/details`, label: 'Details' }]
}

export default function HistoryDetails({ mode = 'view' }: HistoryDetailsProps) {
  const navigate = useNavigate()
  const { id: wellId, historyId } = useParamsOr404('id', 'historyId')
  const [fields, setFields] = useState<Partial<WellHistoryFieldsView>>({})
  const backUrl = `/wells/${wellId}/${mode}/history`

  const url = `audit/${wellId}/history/${historyId}/view`

  const { isLoading, isSuccess, data } = useGetWellData(url)

  useEffect(() => {
    if (isSuccess && data?.state) {
      setFields(data.state)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess, data?.state])

  return (
    <RecordContent>
      <ButtonsContainer containerStyle='left'>
        <Button
          onClick={() => navigate(backUrl, { state: { activeTab: 2 } })}
          label='Back'
          iconAlignment='left'
          icon='arrow-left'
          buttonStyle='text-action'
        />
      </ButtonsContainer>
      <Heading level={2}>Change details</Heading>
      <FormField isSkeleton={isLoading} labelId='modifiedDateFormatted' label='Date'>
        <ReadOnlyField isSkeleton={isLoading} labelledBy='modifiedDateFormatted' value={fields.modifiedDateFormatted} />
      </FormField>
      <FormField isSkeleton={isLoading} labelId='user' label='User'>
        <ReadOnlyField
          isSkeleton={isLoading}
          labelledBy='user'
          value={`${fields.modifiedByFirstName} ${fields.modifiedByLastName}`}
        />
      </FormField>
      <FormField isSkeleton={isLoading} labelId='tableDisplayName' label='Form'>
        <ReadOnlyField isSkeleton={isLoading} labelledBy='tableDisplayName' value={fields.tableDisplayName} />
      </FormField>
      <FormField isSkeleton={isLoading} labelId='columnDisplayName' label='Field'>
        <ReadOnlyField isSkeleton={isLoading} labelledBy='columnDisplayName' value={fields.columnDisplayName} />
      </FormField>
      <FormField isSkeleton={isLoading} labelId='oldValue' label='From'>
        <ReadOnlyField isSkeleton={isLoading} labelledBy='oldValue' value={fields.oldValue} />
      </FormField>
      <FormField isSkeleton={isLoading} labelId='newValue' label='To'>
        <ReadOnlyField isSkeleton={isLoading} labelledBy='newValue' value={fields.newValue} />
      </FormField>
      <FormField isSkeleton={isLoading} labelId='changeTypeLabel' label='+ / - / MOD'>
        <ReadOnlyField isSkeleton={isLoading} labelledBy='changeTypeLabel' value={fields.changeTypeLabel} />
      </FormField>
    </RecordContent>
  )
}
